<script lang="ts" setup>
import './sidebar.scss';
import { onMounted, watch, computed, ref, onBeforeUnmount } from 'vue';
import config from '@/config';
import { onBeforeRouteLeave, onBeforeRouteUpdate, useRoute, useRouter } from 'vue-router';
import { usePerformerStore, type Slice } from '@/stores/performer';
import { useSidebarStore } from '@/stores/sidebar';
import { useTeaserStore } from '@/stores/teaser';
import { useUserStore } from '@/stores/user';
import { useModalsStore } from '@/stores/modals';
import { openTab } from '@/utils';

import tile from '@/components/grid/tile.vue';
import tileTeaser2 from '@/components/grid/tile-teaser.vue';
import tileTeaser from '@/views/teaser/tile.vue';
import { storeToRefs } from 'pinia';
import { useCamStore } from '@/stores/cam';
import { getStaticImages } from '@/utils';

const route = useRoute();
const router = useRouter();

const performerStore = usePerformerStore();
const teaserStore = useTeaserStore();
const userStore = useUserStore();
const { current } = storeToRefs( useTeaserStore() );
const { getMainTeaser: mainTeaser } = useTeaserStore();
const { isLoggedIn } = useUserStore();
const sidebar = useSidebarStore();
const { toggleModal } = useModalsStore();
const sidebarRef = ref(undefined) as HTMLElement | any;
const sideheight: any = ref('100%');
const bodyWidth: any = ref(undefined);

const { currentSlice } = storeToRefs( useSidebarStore() );

onBeforeRouteUpdate((to, from, next) => {
    if (useCamStore().status === 'active' && useCamStore().type === 'chat' && to !== from) {
        if ((userStore.mobile && sidebar.collapse)) {
            sidebar.switchState();
        }
        toggleModal('close', true, to);
    } else {
        next();
    }
})

onBeforeRouteLeave((to, from, next) => {
    if (useCamStore().status === 'active' && to !== from) {
        if ((userStore.mobile && sidebar.collapse)) {
            sidebar.switchState();
        }
        toggleModal('close', true, to);
    } else {
        next();
    }
})

const hiddenSidebar = computed(() => {
    return sidebar.bodyWidth as any < 992 || userStore.mobile;
});

const showHeader = computed(() => {
    const routes = ['videochat', 'teaser'];
    return routes.includes(route.name as string) || userStore.mobile || sidebar.bodyWidth as any < 992;
});

const linkTiles = computed(() => {
    const routes = ['videochat'];
    return routes.includes(route.name as string) && useSidebarStore().activeTab == 'peek' ? 'peek' : 'profile';
});

const inSession = computed(() => {
    return useCamStore().status === 'active';
});

const currentPerformer = computed(() => {
    return inSession.value ? +route.params.advert : undefined;
});

const isVoyeur = computed(() => {
    return sidebar.activeTab === 'voyeur' && route.name === 'teaser';
});

const isTeaser = computed(() => {
    return route.name === 'teaser';
})

function handleSidebarwSizeChange(){
    sidebar.setBodyWidth(window.innerWidth);
    const top = sidebarRef.value && !showHeader.value ? sidebarRef.value.getBoundingClientRect().top : 0;
    const mobile = userStore.mobile && !['videochat', 'teaser'].includes(route.name as string) ? 56 : 0;
    sideheight.value = window.innerHeight - top - mobile + 'px';
}

onMounted(load);

async function load() {
    handleSidebarwSizeChange();
    window.addEventListener('resize', handleSidebarwSizeChange);
    if (useSidebarStore().activeTab == 'none' || (route.name === 'videochat' && route.params.service === 'peek')){
        useSidebarStore().switchTab('peek');
    }
    if (route.name === 'teaser'){
        useSidebarStore().switchTab('voyeur');
    }
}

onBeforeUnmount(() => {
    window.removeEventListener('resize', handleSidebarwSizeChange);
});


async function openPaymentTab() {
    if (userStore.isSafari) {
        router.replace({ path: '/payment/' });
        return;
    }

    toggleModal('payment');
}
</script>

<template src="./sidebar.html"></template>